import api from '../api'
import { DatatableResults } from '../../common/datatables'
import { buildTimesheetsQueryString, buildTimesheetsRequestBody, timesheetPrintUploadUrl, TimesheetsFilters, TimesheetsGridRequest } from './timesheetsModel'

export type TimesheetGpsFlag = {
  hasGpsData: boolean
  isFlagged: boolean
}

export type TimesheetRow = {
  id: string
  timecardId: string
  timecardDate: string | null
  crewMemberId: number
  crewMember: string | null
  costCode: string | null
  division: string | null
  projectId: number
  projectNo: string | null
  projectName: string | null
  projectWorkareaId: number | null
  projectWorkarea: string | null
  customerId: number | null
  customer: string | null
  customerQboId: string | null
  customerQboDisplayName: string | null
  started: string | null
  ended: string | null
  hours: number | null
  lunch: number | null
  totalTime: number
  exported: string | null
  status: number
  createdByEmail: string | null
  createdBy: string | null
  gpsFlag: TimesheetGpsFlag
  isUnbillableTime: boolean
}

export const getTimesheets = async (request: TimesheetsGridRequest): Promise<DatatableResults<TimesheetRow>> => {
  const path = request.deletedView ? '/v2/time/deleted' : '/v2/time/dynamic'
  const body = buildTimesheetsRequestBody(request)
  return (await api.post<DatatableResults<TimesheetRow>>(`${path}${buildTimesheetsQueryString(request.filters)}`, body)).data
}

export type TimesheetFilterOptions = {
  crewMembers: Record<string, string>
}

export const getTimesheetFilterOptions = async (): Promise<TimesheetFilterOptions> => {
  return (await api.get<TimesheetFilterOptions>('/v2/time/filters')).data
}

export type OpenProject = {
  id: number
  customerId: number
  customer: string | null
  projectId: number
  project: string | null
}

export const searchOpenProjects = async (query: string): Promise<OpenProject[]> => {
  return (await api.get<OpenProject[]>(`/v2/time/open/projects?q=${encodeURIComponent(query)}`)).data
}

export const exportTimesheetsToQuickBooks = async (ids: string[]): Promise<string[]> => {
  return (await api.post<string[]>('/quickbooks/timesheets', ids)).data
}

export type PrintReportUpload = {
  url: string
}

export const uploadTimesheetsPrintReport = async (filters: TimesheetsFilters): Promise<PrintReportUpload> => {
  return (await api.post<PrintReportUpload>(timesheetPrintUploadUrl(filters), {})).data
}
